
export const officeTypes = [
  "Ordinário",
  "Encaminhamento",
  "Solicitação",
  "Convocação",
  "Requerimento",
  "Circular",
  "Comunicação ao Executivo",
  "Convite",
  "Moção",
  "Resposta"
] as const;

export const requestTypes = [
  "Informação",
  "Providências",
  "Convocação",
  "Audiência Pública",
  "Inserção em Ata",
  "Voto",
  "Urgência",
  "Licença",
  "Inclusão de Matéria em Pauta",
  "Indicação"
] as const;

export const speechEventTypes = [
  "Sessão plenária",
  "Inauguração",
  "Evento comemorativo",
  "Audiência pública",
  "Debate",
  "Homenagem",
  "Visita à comunidade"
] as const;

export const targetAudienceTypes = [
  "Cidadãos em geral",
  "Técnicos e especialistas",
  "Autoridades e líderes",
  "Representantes de comunidades locais"
] as const;

export const speechObjectiveTypes = [
  "Informar sobre um tema específico",
  "Convencer a audiência de um ponto de vista",
  "Motivar e inspirar ações",
  "Celebrar um marco ou conquista",
  "Protestar ou se posicionar contra um assunto"
] as const;

export const memorandumTypes = [
  "Comunicação Interna",
  "Solicitação", 
  "Encaminhamento",
  "Justificativa",
  "Circular",
  "Convocação",
  "Advertência ou Cobrança"
] as const;

export type OfficeType = (typeof officeTypes)[number];
export type RequestType = (typeof requestTypes)[number];
export type SpeechEventType = (typeof speechEventTypes)[number];
export type TargetAudienceType = (typeof targetAudienceTypes)[number];
export type SpeechObjectiveType = (typeof speechObjectiveTypes)[number];
export type MemorandumType = (typeof memorandumTypes)[number];

